import React, { useState } from 'react';
import { BuildingIcon, CalendarIcon, PercentIcon, FileTextIcon } from 'lucide-react';
export function ProjectDetailsStep({
  initialData,
  onUpdate
}) {
  const [formData, setFormData] = useState({
    projectName: initialData.projectName || '',
    projectDescription: initialData.projectDescription || '',
    projectLocation: initialData.projectLocation || '',
    projectArea: initialData.projectArea || '',
    projectType: initialData.projectType || 'agriculture',
    salesProbability: initialData.salesProbability || '50',
    expectedClosingDate: initialData.expectedClosingDate || '',
    notes: initialData.notes || '',
    ...initialData
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleBlur = () => {
    onUpdate(formData);
  };
  return <div className="space-y-6" data-id="element-4159">
      <div className="text-white text-xl font-medium mb-6" data-id="element-4160">Project Details</div>
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4161">
        <div className="flex items-center mb-4" data-id="element-4162">
          <FileTextIcon size={20} className="text-blue-400 mr-2" data-id="element-4163" />
          <h3 className="text-white font-medium" data-id="element-4164">Basic Information</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4165">
          <div data-id="element-4166">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4167">
              Project Name
            </label>
            <input type="text" name="projectName" value={formData.projectName} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter project name" data-id="element-4168" />
          </div>
          <div data-id="element-4169">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4170">
              Project Location
            </label>
            <input type="text" name="projectLocation" value={formData.projectLocation} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter location (city, country)" data-id="element-4171" />
          </div>
          <div className="md:col-span-2" data-id="element-4172">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4173">
              Project Description
            </label>
            <textarea name="projectDescription" value={formData.projectDescription} onChange={handleChange} onBlur={handleBlur} rows={3} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Briefly describe the project" data-id="element-4174"></textarea>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4175">
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4176">
          <div className="flex items-center mb-4" data-id="element-4177">
            <BuildingIcon size={20} className="text-blue-400 mr-2" data-id="element-4178" />
            <h3 className="text-white font-medium" data-id="element-4179">Project Specifications</h3>
          </div>
          <div className="space-y-4" data-id="element-4180">
            <div data-id="element-4181">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4182">
                Project Area (hectares)
              </label>
              <input type="number" name="projectArea" value={formData.projectArea} onChange={handleChange} onBlur={handleBlur} min="0" step="0.01" className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter area in hectares" data-id="element-4183" />
            </div>
            <div data-id="element-4184">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4185">
                Project Type
              </label>
              <select name="projectType" value={formData.projectType} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-4186">
                <option value="agriculture" data-id="element-4187">Agriculture</option>
                <option value="greenhouse" data-id="element-4188">Greenhouse</option>
                <option value="golf" data-id="element-4189">Golf Course</option>
                <option value="sports" data-id="element-4190">Sports Fields</option>
                <option value="landscaping" data-id="element-4191">Landscaping</option>
                <option value="other" data-id="element-4192">Other</option>
              </select>
            </div>
            <div data-id="element-4193">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4194">Notes</label>
              <textarea name="notes" value={formData.notes} onChange={handleChange} onBlur={handleBlur} rows={3} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Additional notes about the project" data-id="element-4195"></textarea>
            </div>
          </div>
        </div>
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4196">
          <div className="flex items-center mb-4" data-id="element-4197">
            <CalendarIcon size={20} className="text-blue-400 mr-2" data-id="element-4198" />
            <h3 className="text-white font-medium" data-id="element-4199">Sales Information</h3>
          </div>
          <div className="space-y-4" data-id="element-4200">
            <div data-id="element-4201">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4202">
                Sales Probability (%)
              </label>
              <div className="flex items-center" data-id="element-4203">
                <input type="range" name="salesProbability" min="0" max="100" step="5" value={formData.salesProbability} onChange={handleChange} onBlur={handleBlur} className="w-full h-2 bg-slate-700 rounded-lg appearance-none cursor-pointer" data-id="element-4204" />
                <span className="ml-3 text-white font-medium min-w-[3rem] text-right" data-id="element-4205">
                  {formData.salesProbability}%
                </span>
              </div>
              <div className="flex justify-between text-xs text-blue-400 mt-1" data-id="element-4206">
                <span data-id="element-4207">Low</span>
                <span data-id="element-4208">Medium</span>
                <span data-id="element-4209">High</span>
              </div>
            </div>
            <div data-id="element-4210">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4211">
                Expected Closing Date
              </label>
              <div className="relative" data-id="element-4212">
                <input type="date" name="expectedClosingDate" value={formData.expectedClosingDate} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-4213" />
                <CalendarIcon size={18} className="absolute right-3 top-3 text-blue-400 pointer-events-none" data-id="element-4214" />
              </div>
            </div>
            <div className="bg-blue-900/30 rounded-lg p-4 mt-4" data-id="element-4215">
              <div className="flex items-start" data-id="element-4216">
                <PercentIcon size={18} className="text-blue-400 mr-2 mt-0.5" data-id="element-4217" />
                <div data-id="element-4218">
                  <h4 className="text-white text-sm font-medium mb-1" data-id="element-4219">
                    Sales Probability Guide
                  </h4>
                  <ul className="text-xs text-blue-300 space-y-1 list-disc pl-4" data-id="element-4220">
                    <li data-id="element-4221">0-25%: Initial contact, exploring options</li>
                    <li data-id="element-4222">26-50%: Engaged in discussions, some interest shown</li>
                    <li data-id="element-4223">51-75%: Serious interest, negotiating details</li>
                    <li data-id="element-4224">
                      76-100%: Highly likely to close, finalizing agreement
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}